import React, { useEffect } from 'react';
import styled from '@emotion/styled';
import { X } from 'lucide-react';
import { useTranslation } from '../../hooks/useTranslation';

/**
 * SelfAssessmentInfo — the (i) behind the self-assessment: what is stored,
 * how the before and after are paired without a name, who sees what.
 * A plain modal; Escape and the backdrop close it.
 */
const Backdrop = styled.div`position: fixed; inset: 0; background: rgba(0, 0, 0, 0.6); display: grid; place-items: center; padding: 1rem; z-index: 1000;`;
const Box = styled.div`
  width: min(34rem, 100%); max-height: 90vh; overflow: auto; background: #10141c; border: 1px solid #2f3745; border-radius: 12px;
  padding: 1.4rem 1.5rem; color: #e8e8ef; line-height: 1.55; display: flex; flex-direction: column; gap: 0.8rem;
`;
const Head = styled.div`display: flex; align-items: center; justify-content: space-between; gap: 1rem; h2 { margin: 0; font-size: 1.1rem; }`;
const Close = styled.button`all: unset; cursor: pointer; color: #9aa4b2; display: inline-grid; place-items: center; padding: 0.3rem; border-radius: 6px; &:hover, &:focus-visible { color: #fff; background: #232a36; }`;
const P = styled.p`margin: 0; color: #c9cbd6;`;

export default function SelfAssessmentInfo({ open, onClose }) {
  const { t } = useTranslation();
  useEffect(() => {
    if (!open) return undefined;
    const onKey = (e) => { if (e.key === 'Escape') onClose?.(); };
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [open, onClose]);
  if (!open) return null;
  return (
    <Backdrop onClick={onClose}>
      <Box role="dialog" aria-modal="true" aria-labelledby="sa-info-title" onClick={(e) => e.stopPropagation()}>
        <Head><h2 id="sa-info-title">{t('me.selfAssessment.info.title')}</h2><Close type="button" aria-label={t('me.selfAssessment.info.close')} onClick={onClose}><X size={18} /></Close></Head>
        <P>{t('me.selfAssessment.info.stored')}</P>
        <P>{t('me.selfAssessment.info.paired')}</P>
        <P>{t('me.selfAssessment.info.whoSees')}</P>
        <P>{t('me.selfAssessment.info.purpose')}</P>
      </Box>
    </Backdrop>
  );
}
